import { OrganizationSearchResp, Organization } from "../types/types";
import { logger } from "../utils/logger/logger";
import { GetJson } from "./Network";

type FetchOrganizationResponse = Promise<OrganizationSearchResp | undefined>;

export const fetchOrganization = async (url: string): FetchOrganizationResponse | undefined => {
  try {
    const responseEntries = (await GetJson(url)) as OrganizationSearchResp;
    return (responseEntries || []).map((entry) => mapOrg(entry)) as OrganizationSearchResp;
  } catch (e) {
    logger.warn(e, "failed to fetchOrganization"); // the error is already logged by fetchWithTimeout
  }
};

function mapOrg(sourceOrg: Organization): Organization {
  return {
    id: sourceOrg.id,
    idExtended: sourceOrg.idExtended === undefined ? sourceOrg.id.toString() : sourceOrg.idExtended,
    name: sourceOrg.name,
    country: sourceOrg.country,
    source: sourceOrg.source,
  };
}
